import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { Problem } from "../components/Problem";
import { MeetLint } from "../components/MeetLint";
import { CtoLayer } from "../components/CtoLayer";
import { Journey } from "../components/Journey";
import { DemoCta } from "../components/DemoCta";
import { WhyBootRise } from "../components/WhyBootRise";
import { FinalCta } from "../components/FinalCta";
import { Footer } from "../components/Footer";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Problem />
        <MeetLint />
        <CtoLayer />
        <Journey />
        <DemoCta />
        <WhyBootRise />
        <FinalCta />
      </main>
      <Footer />
    </>
  );
}
